export const environment = {
    production: true,
    api: 'https://api.pre.tk.omniflou.com',
    storage: 'https://cdn.pre.tk.in.omniflou.com',
    cdn: 'https://cdn.tk.pre.omniflou.com/',
    adminUrl: 'https://admin.tk.pre.omniflou.com/',
    wsServer: 'https://ws.pre.tk.omniflou.com/videolink',
  }
  